module.exports = __webpack_public_path__ + "static/img/bg-open.e1ba7c84.png";